import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { ensureTrailingSlashLocal } from '../utils/ensureTrailingSlash';
import isExternalURL from '../utils/isExternalURL';

function A(props) {
  return (
    <a {...props} target={props.target || '_self'}>
      {props.children}
    </a>
  );
}
function Div(props) {
  return <div {...props}>{props.children}</div>;
}

class Button extends React.Component {
  render() {
    const props = [
      // 'raised',
      'lg',
      'sm',
      'disabled',
      'primary',
      'gold',
      'yellow',
      'grey',
      'cloud',
      'secondary',
      'warning',
      'success',
      'solid',
      'outline',
      'pink',
      'black',
      'square',
      'fullwidth',
      'text',
      'color',
    ];

    const falsy = [undefined, 0, false];

    const classes = {
      BtnV2: true,
    };
    props.forEach((p) => {
      if (p === 'color') {
        classes[`BtnV2--${this.props[p]}`] = true;
      } else {
        classes[`BtnV2--${p}`] = falsy.indexOf(this.props[p]) === -1;
      }
    });

    if (this.props.className) {
      classes[this.props.className] = 1;
    }

    let WrapperElement = Div;
    let target = '';

    if (this.props.to) WrapperElement = Link;
    if (this.props.href) {
      WrapperElement = A;
      target = isExternalURL(this.props.href) ? '_blank' : '_self';
    }
    if (this.props.component) WrapperElement = this.props.component;

    return (
      <WrapperElement
        {...this.props}
        to={ensureTrailingSlashLocal(this.props.to)}
        onClick={(e) =>
          !this.props.disabled && this.props.onClick && this.props.onClick(e)
        }
        className={classnames(classes)}
        target={target}
      >
        <span>{this.props.children}</span>
      </WrapperElement>
    );
  }
}

export default Button;
